export enum BooleanStrEnum {
  true = 'true',
  false = 'false',
}
